/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
import React, { useLayoutEffect, useRef } from "react";
import { Modal, LegacyStack } from "@shopify/polaris";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import UserForm from "features/user-form/user-form";
import CustomerForm from "features/customer-form/customer-form";
import CompanyForm from "features/company-create/company-create";
import InvoiceSettingsForm from "features/invoice-settings-form/invoice-settings-form";
import OrdersProductForm from "features/orders-product-form/orders-product-form";
import VatForm from "features/vat-form/vat-form";
import ProductForm from "features/product-form/product-form";
import BuildPdfForm from "components/customer/build-pdf/BuildPdfForm";
import ProjectBoardForm from "containers/project-board-form/project-board-form";
import ShareBoardForm from "containers/share-board-form/share-board-form";
import MoveProjectToBoardForm from "containers/move-project-to-board-form/move-project-to-board-form";
import { setIsModalxOpen, setDestroy } from "./modalx.slice";
// import './style.scss';
import FilesCategoryForm from "containers/files-category-form/files-category-form";
import ProjectBoardColumnForm from "containers/project-board-column-form/project-board-column-form";
import ProjectForm from "containers/project-form/project-form";
import FileForm from "containers/file-form/file-form";
import ContactForm from "containers/contact-form/contact-form";
import Loading from "components/loading/Loading";
import AddFilesCategoryForm from "containers/files-categories-add-form/files-category-form";
import InfoFilesCategory from "containers/info-files-category/info-files-category";
import PdfView from "components/pdf-view/Pdf_modal";
import AssetActModal from "components/asset-act-modal/asset-act-modal";
import QuestionnaireConfirmPopup from "components/customer-questionnaire-confirm-popup/customer-questionnaire-confirm";
import CustomerQuestionnaireCrossCompanyConfirm from "components/customer-questionnaire-cross-company-confirm/customer-questionnaire-cross-company-confirm";
import CustomerApproveConfirmPopup from "components/customer-approval-popup/customer-approval-confirm";
import SignRequestConfirmPopup from "components/file-sign-request-confirm/file-sign-request-confirm";
import CustomerFinaceSignConfirmPopup from "components/customer-finance-sign-confirm/customer-finance-sign-confirm";
import CustomerFinanceSaveConfirm from "components/customer-finance-save-confirm/customer-finance-save-confirm";
import FileSignAssignPopup from "components/files-sign-assign/file-sign-assign";
import AddressForm from "containers/address-form/address-form";
import SignRequestCancelPopup from "components/file-sign-request-cancel/file-sign-request-cancel";
import BusinessTripDocumentForm from "components/customer/build-pdf/flows/BusinessTripDocumentForm";
import OrderDocumentForm from "components/customer/build-pdf/flows/OrderDocumentForm";
import UserDocumentForm from "components/customer/build-pdf/flows/UserDocumentForm";
import FuelReportDocumentForm from "components/customer/build-pdf/flows/FuelReportDocumentForm";
import ResendEmailConfirm from "components/email-resend-approval-popup/email-resend-request-confirm";
import ManualSignSendMailConfirm from "components/manual-sign-send-email-confirm/manual-sign-send-email-confirm";
import FileSignUserAssignPopup from "components/files-sign-user-assign/file-sign-user-assign";
import FileSignMultiUserAssignPopup from "components/files-sign-multi-user-assign/file-sign-multi-user-assign";
import ClickToSignConfirm from "components/click-to-sign-confirm/click-to-sign-confirm";
import AddClickSigner from "components/add-click-signers/add-click-signer-confirm";
import DeclineClickSignConfirm from "components/decline-click-sign-request/decline-click-sign-confirm";
import AnnulReportConfirm from "components/annul-report-confirm/annul-report-confirm";
import DeclineDokobitSignConfirm from "components/decline-dokobit-sign-request/decline-dokobit-sign-confirm";
import ResetFileSignaturesConfirm from "components/reset-file-signatures-confirm/reset-file-signatures-confirm";
import AnnulDocumentConfirm from "components/annul-document-confirm/annul-document-confirm";
import WithdrawDocumentConfirm from "components/withdraw-document-confirm/withdraw-document-confirm";
import DokobitSignerRemoveConfirm from "components/dokobit-signer-remove-confirm/dokobit-signer-remove-confirm";
import ClickSignerRemoveConfirm from "components/click-signer-remove-confirm/click-signer-remove-confirm";
import FileSigningCancelConfirm from "components/file-signing-cancel-confirm/file-signing-cancel-confirm";
import AssetsForm from "containers/assets-form/assets-form";
import UserAssignToAssetsForm from "containers/assets-user-assign-form/assets-user-assign-form";
import FileReviewConfirmPopup from "components/review-file-confirm/review-file-confirm";
import AssetForceReturnConfirm from "components/return-asset-confirm/return-asset-confirm";
import AssetsReturnForm from "containers/assets-return-form/assets-return-form";
import FuelReportForm from "containers/fuel-report-form/fuel-report-form";
import BusinessTripForm from "containers/business-trip-form/business-trip-form";
import BusinessTripReportForm from "containers/business-trip-report-form/business-trip-report-form";
import BusinessTripExpenseForm from "containers/business-trip-expenses/business-trip-expense-form";
import AddAdditionalSigners from "components/files-multi-user-additional-signature/files-multi-user-additional-signature";
import EditEmailForm from "features/edit-email-form/edit-email-form";
import RefuseFuelReportConfirm from "components/refuse-fuel-report-confirm/refuse-fuel-report-confirm";
import CategoryFavoriteConfirm from "components/category-favorite-confirm/category-favorite-confirm";
import ReminderSettingsModal from "components/reminder-settings-modal/reminder-settings-modal";
import DeliveryForm from "features/deliveries/components/DeliveryForm";
import ReservationForm from "features/reservations/components/ReservationForm";
import CreateFinanceYearConfirm from "components/create-finance-year-confirm/create-finance-year-confirm";
import LeaveCalendarLeaveModal from "features/leave-calendar/LeaveCalendarLeaveModal";
import OnboardingForm from "containers/onboarding-form/onboarding-form";
import JobLeaveForm from "containers/job-leave-form/job-leave-form";
import JobLeaveConfirmModal from "containers/job-leave-form/job-leave-confirm-modal";
import JobLeaveRemoveSignatureModal from "containers/job-leave-form/job-leave-remove-signature-modal";
import ApproveMedicalModal from "components/approve-medical-modal/approve-medical-modal";
import ApproveMedicalCheckModal from "components/approve-medical-check-modal/approve-medical-check-modal";
import AvatarUploadModal from "components/avatar-upload-modal/avatar-upload-modal";
import UserPublicProfileModal from "components/user-public-profile-modal/user-public-profile-modal";
import GiveKudosModal from "components/give-kudos-modal/give-kudos-modal";
import WorkSecurityRoleFormModal from "containers/work-security/WorkSecurityRoleFormModal";
import WorkSecurityGroupsModal from "containers/work-security/WorkSecurityGroupsModal";
import WorkSecurityRoleEditModal from "containers/work-security/WorkSecurityRoleEditModal";
import WorkSecurityArchiveConfirmModal from "containers/work-security/WorkSecurityArchiveConfirmModal";
import WorkSecurityRulesAmendModal from "containers/work-security/WorkSecurityRulesAmendModal";
import WorkSecurityUnassignConfirmModal from "containers/work-security/WorkSecurityUnassignConfirmModal";
import WorkSecurityUserRolesModal from "containers/work-security/WorkSecurityUserRolesModal";
import WorkSecuritySelectDocumentModal from "containers/work-security/WorkSecuritySelectDocumentModal";
import DocumentTreePickerModal from "features/document-tree-picker/DocumentTreePickerModal";
import IncidentFormModal from "containers/work-security/IncidentFormModal";
import TrainingTestFormModal from "containers/work-security/TrainingTestFormModal";
import IncidentSendForSignatureModal from "containers/work-security/IncidentSendForSignatureModal";
import DepartmentForm from "containers/departments/form/form";
import OnboardingDepartmentModal from "components/onboarding-department-modal/onboarding-department-modal";
import AddFolderToCartConfirm from "features/document-cart/AddFolderToCartConfirm";
import ValidationAttemptDetailModal from "components/customer-form-validation-attempts/validation-attempt-detail-modal";
import InvoiceForm from "features/invoice-form/invoice-form";
import CreateInvoiceModal from "features/create-invoice-modal/create-invoice-modal";
import CloseOrderConfirm from "containers/order-view-container/close-order-confirm";
import AttachExternalDocument from "containers/order-view-container/attach-external-document";
import DeleteDraftInvoiceDialog from "containers/outgoing-invoices/delete-draft-invoice-dialog";
import DeleteDeskCardConfirm from "components/delete-desk-card-confirm/delete-desk-card-confirm";
import RestoreDeskCardConfirm from "components/restore-desk-card-confirm/restore-desk-card-confirm";

function Modalx() {
  const {
    title,
    isOpen,
    component,
    primaryAction,
    secondaryActions,
    size,
    componentProps,
  } = useSelector((state) => state.modalxReducer);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);

  // Links inside a modal open in the current tab now, so the modal has to leave
  // with the page it belonged to instead of hanging over the new one. A layout
  // effect, so a page that opens a modal of its own on arrival wins the race.
  useLayoutEffect(() => {
    if (pathnameRef.current === pathname) return;
    pathnameRef.current = pathname;
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  }, [pathname, dispatch]);

  const closeModal = (e) => {
    if (e?.target) {
      dispatch(setIsModalxOpen(false));
      dispatch(setDestroy());
    }
  };

  const components = {
    CompanyForm,
    UserForm,
    CustomerForm,
    InvoiceSettingsForm,
    OrdersProductForm,
    VatForm,
    ProductForm,
    BuildPdfForm,
    ProjectBoardForm,
    ShareBoardForm,
    MoveProjectToBoardForm,
    ProjectForm,
    FileForm,
    Loading,
    FilesCategoryForm,
    ProjectBoardColumnForm,
    ContactForm,
    AddFilesCategoryForm,
    PdfView,
    AssetActModal,
    QuestionnaireConfirmPopup,
    CustomerQuestionnaireCrossCompanyConfirm,
    CustomerApproveConfirmPopup,
    SignRequestConfirmPopup,
    CustomerFinaceSignConfirmPopup,
    CustomerFinanceSaveConfirm,
    FileSignAssignPopup,
    AddressForm,
    SignRequestCancelPopup,
    BusinessTripDocumentForm,
    OrderDocumentForm,
    UserDocumentForm,
    FuelReportDocumentForm,
    ResendEmailConfirm,
    ManualSignSendMailConfirm,
    FileSignUserAssignPopup,
    FileSignMultiUserAssignPopup,
    ClickToSignConfirm,
    AddClickSigner,
    DeclineClickSignConfirm,
    AnnulReportConfirm,
    DeclineDokobitSignConfirm,
    ResetFileSignaturesConfirm,
    AnnulDocumentConfirm,
    WithdrawDocumentConfirm,
    DokobitSignerRemoveConfirm,
    ClickSignerRemoveConfirm,
    FileSigningCancelConfirm,
    AssetsForm,
    UserAssignToAssetsForm,
    FileReviewConfirmPopup,
    InfoFilesCategory,
    AssetForceReturnConfirm,
    AssetsReturnForm,
    FuelReportForm,
    BusinessTripForm,
    BusinessTripReportForm,
    BusinessTripExpenseForm,
    AddAdditionalSigners,
    EditEmailForm,
    RefuseFuelReportConfirm,
    CategoryFavoriteConfirm,
    ReminderSettingsModal,
    DeliveryForm,
    ReservationForm,
    CreateFinanceYearConfirm,
    LeaveCalendarLeaveModal,
    OnboardingForm,
    JobLeaveForm,
    JobLeaveConfirmModal,
    JobLeaveRemoveSignatureModal,
    ApproveMedicalModal,
    ApproveMedicalCheckModal,
    AvatarUploadModal,
    UserPublicProfileModal,
    GiveKudosModal,
    WorkSecurityRoleFormModal,
    WorkSecurityGroupsModal,
    WorkSecurityRoleEditModal,
    WorkSecurityArchiveConfirmModal,
    WorkSecurityRulesAmendModal,
    WorkSecurityUnassignConfirmModal,
    WorkSecurityUserRolesModal,
    WorkSecuritySelectDocumentModal,
    DocumentTreePickerModal,
    IncidentFormModal,
    TrainingTestFormModal,
    IncidentSendForSignatureModal,
    DepartmentForm,
    OnboardingDepartmentModal,
    AddFolderToCartConfirm,
    ValidationAttemptDetailModal,
    DeleteDeskCardConfirm,
    RestoreDeskCardConfirm,
    InvoiceForm,
    CreateInvoiceModal,
    CloseOrderConfirm,
    AttachExternalDocument,
    DeleteDraftInvoiceDialog,
  };

  const ComponentNode = components[component];
  if (!ComponentNode) return null;
  return (
    <Modal
      title={title || null}
      primaryAction={primaryAction || null}
      secondaryActions={secondaryActions || null}
      open={isOpen}
      onClose={closeModal}
      size={size}
    >
      <Modal.Section>
        <LegacyStack vertical>
          <ComponentNode {...componentProps} />
        </LegacyStack>
      </Modal.Section>
    </Modal>
  );
}

export default Modalx;
